import React, {createContext, useEffect, useState} from 'react'
import {fetchBlackList} from "../../../api/blackList"
import {message} from "antd"

const initialState = {
    isLoading: false,
    blackList: [
        {
            id: '',
            note: '',
            account: '',
            member_name: '',
            nickname: '',
            club_name: '',
            member_id: '',
        }
    ],
    page: {
        total: 0,
        current: 1,
    },
    searchInput: '',
    getBlackList: async () => {
    },
    onSearchChange: (value) => {}
}

export const BlackListContext = createContext(initialState)

export const BlackListProvider = ({children}) => {

    const [isLoading, setIsLoading] = useState(false)
    const [blackList, setBlackList] = useState([])
    const [page, setPage] = useState(initialState.page)
    const [searchInput, setSearchInput] = useState(initialState.searchInput)

    const getBlackList = async () => {
        setIsLoading(true)
        await fetchBlackList(page.current, searchInput).then((res) => {
            setPage(prevState => {
                return {
                    ...prevState,
                    total: res.count
                }
            })
            setBlackList(res.list)
        }).catch(err => {
            console.log(err)
            message.error(`获取黑名单列表失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const onSearchChange = (value) => {
        setSearchInput(value)
    }

    useEffect(() => {
        getBlackList()
    }, [page.current, searchInput])

    const value = {
        isLoading,
        blackList,
        page,
        searchInput,
        getBlackList,
        onSearchChange
    }

    return (
        <BlackListContext.Provider value={value}>
            {children}
        </BlackListContext.Provider>
    )
}

export const useBlackListContext = () => {
    const context = React.useContext(BlackListContext)
    if (context === undefined) {
        throw new Error('useBlackListContext must be used within a BlackListProvider')
    }
    return context
}


// WEBPACK FOOTER //
// ./src/containers/ClubBlacklist/store/useBlackListContext.js